import React, { forwardRef, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../config/styles';
import { theme } from '../../styles/theme';
import { IStyled } from '../../styles/types';

type BadgeColor = 'orange' | 'purple' | 'grey' | 'red' | 'blue';

type BadgeSize = 'primary' | 'secondary';

interface IProps extends IStyled {
  color: BadgeColor;
  size: BadgeSize;
  children?: ReactNode;
}

interface IStyledBadge {
  $color: BadgeColor;
  $size: BadgeSize;
}

const badgeColorConfig: Record<BadgeColor, string> = {
  red: colors.mainError,
  orange: '#fd7e14',
  purple: colors.purple,
  grey: theme.colors.secondary600,
  blue: '#0a63ba',
};

const primaryBadgeStyles = css`
  height: 16px;
  font-size: 12px;
`;

const secondaryBadgeStyles = css`
  height: 12px;
  font-size: 8px;
`;

const StyledBadge = styled.span<IStyledBadge>`
  display: inline-flex;
  align-items: center;
  column-gap: 2px;
  flex: 0 0 auto;
  padding-right: 3px;
  padding-left: 3px;
  border-radius: 2px;
  background-color: ${({ $color }) => badgeColorConfig[$color]};
  font-weight: 600;
  line-height: normal;
  color: ${theme.colors.white};
  ${({ $size }) => {
    if ($size === 'primary') {
      return primaryBadgeStyles;
    }

    return secondaryBadgeStyles;
  }}
`;

const Badge = forwardRef<HTMLSpanElement, IProps>(
  ({ color, size, children, className }, ref) => (
    <StyledBadge ref={ref} className={className} $color={color} $size={size}>
      {children}
    </StyledBadge>
  ),
);

export default Badge;
